// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"Welcome_logoContainer__3WtyV","logo":"Welcome_logo__3YQQ5","loader":"Welcome_loader__2cCzh","spin":"Welcome_spin__3QHzK","welcomeText":"Welcome_welcomeText__g-Eku"};